import { Component, Input } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'default-template',
	templateUrl: './default-template.component.html',
	styleUrls: []
})
export class DefaultTemplateComponent {
	@Input() public dcrKey: string;
}
